module.exports = __webpack_public_path__ + "components/country-flag/static/am-cd254a50ed0a06cfd5b298737bfc7b73.svg";